<style scoped>
.humtog_s {
  margin-bottom: 27px;
}
</style>
<template>
  <div class="sidebar-right comtt_c">
    <el-card class="box-card humtog_s">
      <h2 class="community_chanel">What is Humtog?</h2>
      <p>
        Humtog is a collaboration platform to make it possible for people to work together in achieving common goals like eradicating poverty or illiteracy. We can solve most problems in this world if a few good people come together to fix them. This is a platform for such people.
        <br>
        <br>As you can see, that is not an easy thing to do. So, we are currently just a news discussion platform until we get a large enough user-base to achieve our main goal. Join Humtog and let's save the world bit by bit.
      </p>
      <div style="text-align: center">
        <router-link class="item h_b" to="/">Learn More</router-link>
      </div>
    </el-card>
<!--     <el-card class="box-card humtog_s">
      <h2 class="community_chanel">Project NewsWorthy</h2>
      <p>We are starting an initiative to filter out the cluter in the news and just show the most important news of the day in a gist. Join it to help us fight the fake news.</p>
      <div style="text-align: center">
        <router-link class="item h_b" to="/signup">Learn More</router-link>
      </div>
    </el-card>
    <el-card class="box-card humtog_s">
      <div>
        <h2 class="community_chanel">Feed Filters</h2>
        <div class="f_f_m">
          <div class="f_f">
            <router-link :to="{ path: '/' }" class="nav-itemis-tab">News Only ></router-link>
          </div>
          <div class="f_f">
            <router-link :to="{ path: '/' }" class="nav-itemis-tab">Articals Only ></router-link>
          </div>
          <div class="f_f">
            <router-link :to="{ path: '/' }" class="nav-itemis-tab">Q&A Only ></router-link>
          </div>
          <div class="f_f">
            <router-link :to="{ path: '/' }" class="nav-itemis-tab">Photos Only ></router-link>
          </div>
        </div>
      </div>
    </el-card> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  watch: {},

  computed: {},

  created() {},

  methods: {}
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/sidebars/HomeSidebar.vue